import * as React from 'react';

const styles = require('./ReimbursementFlagsChips.pcss');

type Props = {
  flags: Record<string, boolean> | null;
};

const ReimbursementFlagsChips: React.FC<Props> = ({ flags }) => {
  if (!flags) {
    return null;
  }

  return (
    <div className={styles.flagsContainer}>
      {flags.virtualAccountSynced ? (
        <div className={styles.flagSuccess}>Reimbursement KYC Approved</div>
      ) : (
        ''
      )}
      {flags.reimbursementsPaused ? (
        <div className={styles.flagWarning}>Reimbursements Paused</div>
      ) : (
        ''
      )}
    </div>
  );
};

export default ReimbursementFlagsChips;
